import { render, staticRenderFns } from "./Transfer_setting.vue?vue&type=template&id=5b886c99&scoped=true&"
import script from "./Transfer_setting.vue?vue&type=script&lang=js&"
export * from "./Transfer_setting.vue?vue&type=script&lang=js&"
import style0 from "./Transfer_setting.vue?vue&type=style&index=0&id=5b886c99&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b886c99",
  null
  
)

export default component.exports